<template>
  <MainContainer>
    <LanguageSelect
      v-model="selectedLanguage"
      :langs="langs"
      style="top: 0"
      hide-button
    />
    <div class="custom-pages__constructor">
      <HeaderBlock />
      <div class="divider" />
      <ContentBlock />
    </div>
  </MainContainer>
</template>
<script>
import MainContainer from '@/components/main/mainContainer'
import LanguageSelect from '@/components/custom/languageSelect.vue'

import HeaderBlock from '@/views/apps/custom-pages/constructor/content/headerBlock.vue'
import ContentBlock from '@/views/apps/custom-pages/constructor/content/contentBlock.vue'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    MainContainer,
    LanguageSelect,
    HeaderBlock,
    ContentBlock,
  },
  computed: {
    ...mapState({
      langs: state => state.langs.langData,
    }),
    ...mapGetters('content', ['selectedLanguage', 'isContentPageFilled']),
    selectedLanguage: {
      get() {
        return this.$store.getters['content/selectedLanguage']
      },
      set(value) {
        this.setSelectedLanguage(value)
      },
    },
  },
  methods: {
    ...mapActions(['GET_LANGS']),
    ...mapActions('content', ['setSelectedLanguage']),
  },
  async created() {
    if (this.langs?.length === 0) {
      await this.GET_LANGS()
    }
  },
}
</script>
<style>
.custom-pages__constructor .block__header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.custom-pages__constructor .block__title {
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 0;
}

.custom-pages__constructor .divider {
  height: 1px;
  background-color: #d9d9d9;
  margin: 24px 0;
}
</style>
